<template>
  <span>
    {{ startDate | formatDateDMY }}
    &nbsp; - &nbsp;
    {{ endDate | formatDateDMY }}
  </span>
</template>

<script>
export default {
  name: 'announcement-dates',
  components: {},
  props: {
    startDate: {
      type: [String, Date],
      default: '',
    },
    endDate: {
      type: [String, Date],
      default: '',
    },
  },
}
</script>

<style scoped>

</style>
